module.exports = __webpack_public_path__ + "img/eematico-toys-jucarii-pachet-dynamic.17f97bb0.jpg";